//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AuditClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: {fetch(url: RequestInfo, init?: RequestInit): Promise<Response>}
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  getAudits(filter: FilterViewModel): Promise<AuditViewModel[]> {
    let url_ = this.baseUrl + '/v2/Audit/GetAudits';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(filter);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAudits(_response);
    });
  }

  protected processGetAudits(response: Response): Promise<AuditViewModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as AuditViewModel[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<AuditViewModel[]>(null as any);
  }
}

export class ClientClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: {fetch(url: RequestInfo, init?: RequestInit): Promise<Response>}
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  getClient(clientId: number | undefined): Promise<Client> {
    let url_ = this.baseUrl + '/api/v2/Client/GetClient?';
    if (clientId === null)
      throw new Error("The parameter 'clientId' cannot be null.");
    else if (clientId !== undefined)
      url_ += 'clientId=' + encodeURIComponent('' + clientId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetClient(_response);
    });
  }

  protected processGetClient(response: Response): Promise<Client> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as Client);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<Client>(null as any);
  }

  getClients(): Promise<Client[]> {
    let url_ = this.baseUrl + '/api/v2/Client/GetClients';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetClients(_response);
    });
  }

  protected processGetClients(response: Response): Promise<Client[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as Client[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<Client[]>(null as any);
  }

  addClient(client: Client): Promise<number> {
    let url_ = this.baseUrl + '/api/v2/Client/AddClient';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(client);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processAddClient(_response);
    });
  }

  protected processAddClient(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as number);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<number>(null as any);
  }

  updateClient(client: Client): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Client/UpdateClient';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(client);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateClient(_response);
    });
  }

  protected processUpdateClient(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  removeClient(clientId: number | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Client/RemoveClient?';
    if (clientId === null)
      throw new Error("The parameter 'clientId' cannot be null.");
    else if (clientId !== undefined)
      url_ += 'clientId=' + encodeURIComponent('' + clientId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRemoveClient(_response);
    });
  }

  protected processRemoveClient(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export class EmailClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: {fetch(url: RequestInfo, init?: RequestInit): Promise<Response>}
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  sendExpirationMail(): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Email/SendExpirationMail';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processSendExpirationMail(_response);
    });
  }

  protected processSendExpirationMail(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export class LicenseClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: {fetch(url: RequestInfo, init?: RequestInit): Promise<Response>}
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  getLicense(request: GetLicenseRequest): Promise<string> {
    let url_ = this.baseUrl + '/v2/License/GetLicense';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetLicense(_response);
    });
  }

  protected processGetLicense(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<string>(null as any);
  }

  getLicense2(
    email: string | null | undefined,
    productGuid: string | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/License/GetLicense';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (email !== null && email !== undefined)
      content_.append('Email', email.toString());
    if (productGuid === null || productGuid === undefined)
      throw new Error("The parameter 'productGuid' cannot be null.");
    else content_.append('ProductGuid', productGuid.toString());

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetLicense2(_response);
    });
  }

  protected processGetLicense2(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<string>(null as any);
  }

  getAvailableDemoPermissions(
    email: string | null | undefined,
    productGuid: string | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/License/GetAvailableDemoPermissions';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (email !== null && email !== undefined)
      content_.append('Email', email.toString());
    if (productGuid === null || productGuid === undefined)
      throw new Error("The parameter 'productGuid' cannot be null.");
    else content_.append('ProductGuid', productGuid.toString());

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetAvailableDemoPermissions(_response);
    });
  }

  protected processGetAvailableDemoPermissions(
    response: Response
  ): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as string);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<string>(null as any);
  }

  requestDemoPermission(
    email: string | null | undefined,
    productGuid: string | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/License/RequestDemoPermission';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (email !== null && email !== undefined)
      content_.append('Email', email.toString());
    if (productGuid === null || productGuid === undefined)
      throw new Error("The parameter 'productGuid' cannot be null.");
    else content_.append('ProductGuid', productGuid.toString());

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRequestDemoPermission(_response);
    });
  }

  protected processRequestDemoPermission(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export class ProductClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: {fetch(url: RequestInfo, init?: RequestInit): Promise<Response>}
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  getProducts(): Promise<Product[]> {
    let url_ = this.baseUrl + '/api/v2/Product/GetProducts';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetProducts(_response);
    });
  }

  protected processGetProducts(response: Response): Promise<Product[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as Product[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<Product[]>(null as any);
  }

  addProduct(product: Product): Promise<number> {
    let url_ = this.baseUrl + '/api/v2/Product/AddProduct';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(product);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processAddProduct(_response);
    });
  }

  protected processAddProduct(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as number);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<number>(null as any);
  }

  updateProduct(product: Product): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Product/UpdateProduct';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(product);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateProduct(_response);
    });
  }

  protected processUpdateProduct(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  removeProduct(productId: number | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Product/RemoveProduct?';
    if (productId === null)
      throw new Error("The parameter 'productId' cannot be null.");
    else if (productId !== undefined)
      url_ += 'productId=' + encodeURIComponent('' + productId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRemoveProduct(_response);
    });
  }

  protected processRemoveProduct(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  addProductVersion(data: ProductVersion): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Product/AddProductVersion';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processAddProductVersion(_response);
    });
  }

  protected processAddProductVersion(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  updateProductVersion(data: ProductVersion): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Product/UpdateProductVersion';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(data);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateProductVersion(_response);
    });
  }

  protected processUpdateProductVersion(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  removeProductVersion(productVersionId: number): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Product/RemoveProductVersion';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(productVersionId);

    let options_: RequestInit = {
      body: content_,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRemoveProductVersion(_response);
    });
  }

  protected processRemoveProductVersion(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  getProductVersions(productId: number | undefined): Promise<ProductVersion[]> {
    let url_ = this.baseUrl + '/api/v2/Product/GetProductVersions?';
    if (productId === null)
      throw new Error("The parameter 'productId' cannot be null.");
    else if (productId !== undefined)
      url_ += 'productId=' + encodeURIComponent('' + productId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetProductVersions(_response);
    });
  }

  protected processGetProductVersions(
    response: Response
  ): Promise<ProductVersion[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ProductVersion[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ProductVersion[]>(null as any);
  }
}

export class ProductSettingClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: {fetch(url: RequestInfo, init?: RequestInit): Promise<Response>}
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  getProductSettings(clientId: number | undefined): Promise<ProductSetting[]> {
    let url_ = this.baseUrl + '/api/v2/ProductSetting/GetProductSettings?';
    if (clientId === null)
      throw new Error("The parameter 'clientId' cannot be null.");
    else if (clientId !== undefined)
      url_ += 'clientId=' + encodeURIComponent('' + clientId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetProductSettings(_response);
    });
  }

  protected processGetProductSettings(
    response: Response
  ): Promise<ProductSetting[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as ProductSetting[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<ProductSetting[]>(null as any);
  }

  addProductSetting(productSetting: ProductSetting): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/ProductSetting/AddProductSetting';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(productSetting);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processAddProductSetting(_response);
    });
  }

  protected processAddProductSetting(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  updateProductSetting(productSetting: ProductSetting): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/ProductSetting/UpdateProductSetting';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(productSetting);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateProductSetting(_response);
    });
  }

  protected processUpdateProductSetting(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  removeProductSetting(
    productId: number | undefined,
    clientId: number | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/ProductSetting/RemoveProductSetting?';
    if (productId === null)
      throw new Error("The parameter 'productId' cannot be null.");
    else if (productId !== undefined)
      url_ += 'productId=' + encodeURIComponent('' + productId) + '&';
    if (clientId === null)
      throw new Error("The parameter 'clientId' cannot be null.");
    else if (clientId !== undefined)
      url_ += 'clientId=' + encodeURIComponent('' + clientId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRemoveProductSetting(_response);
    });
  }

  protected processRemoveProductSetting(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export class SubscriptionClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: {fetch(url: RequestInfo, init?: RequestInit): Promise<Response>}
  ) {
    this.http = http ? http : (window as any);
    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  getSubscription(
    clientId: number | undefined
  ): Promise<SubscriptionViewModel[]> {
    let url_ = this.baseUrl + '/api/v2/Subscription/GetSubscription?';
    if (clientId === null)
      throw new Error("The parameter 'clientId' cannot be null.");
    else if (clientId !== undefined)
      url_ += 'clientId=' + encodeURIComponent('' + clientId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processGetSubscription(_response);
    });
  }

  protected processGetSubscription(
    response: Response
  ): Promise<SubscriptionViewModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(
                _responseText,
                this.jsonParseReviver
              ) as SubscriptionViewModel[]);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SubscriptionViewModel[]>(null as any);
  }

  addSubscription(subscription: Subscription): Promise<number> {
    let url_ = this.baseUrl + '/api/v2/Subscription/AddSubscription';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(subscription);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processAddSubscription(_response);
    });
  }

  protected processAddSubscription(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : (JSON.parse(_responseText, this.jsonParseReviver) as number);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<number>(null as any);
  }

  resetSubscription(subscriptionId: number | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Subscription/ResetSubscription?';
    if (subscriptionId === null)
      throw new Error("The parameter 'subscriptionId' cannot be null.");
    else if (subscriptionId !== undefined)
      url_ += 'subscriptionId=' + encodeURIComponent('' + subscriptionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processResetSubscription(_response);
    });
  }

  protected processResetSubscription(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  extendSubscription(
    subscriptionId: number | undefined,
    newExpiration: Date | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Subscription/ExtendSubscription?';
    if (subscriptionId === null)
      throw new Error("The parameter 'subscriptionId' cannot be null.");
    else if (subscriptionId !== undefined)
      url_ += 'subscriptionId=' + encodeURIComponent('' + subscriptionId) + '&';
    if (newExpiration === null)
      throw new Error("The parameter 'newExpiration' cannot be null.");
    else if (newExpiration !== undefined)
      url_ +=
        'newExpiration=' +
        encodeURIComponent(
          newExpiration ? '' + newExpiration.toISOString() : ''
        ) +
        '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processExtendSubscription(_response);
    });
  }

  protected processExtendSubscription(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  updateMaxUsers(
    subscriptionId: number | undefined,
    newMaxUsers: number | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Subscription/UpdateMaxUsers?';
    if (subscriptionId === null)
      throw new Error("The parameter 'subscriptionId' cannot be null.");
    else if (subscriptionId !== undefined)
      url_ += 'subscriptionId=' + encodeURIComponent('' + subscriptionId) + '&';
    if (newMaxUsers === null)
      throw new Error("The parameter 'newMaxUsers' cannot be null.");
    else if (newMaxUsers !== undefined)
      url_ += 'newMaxUsers=' + encodeURIComponent('' + newMaxUsers) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'POST',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateMaxUsers(_response);
    });
  }

  protected processUpdateMaxUsers(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  removeSubscription(subscriptionId: number | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Subscription/RemoveSubscription?';
    if (subscriptionId === null)
      throw new Error("The parameter 'subscriptionId' cannot be null.");
    else if (subscriptionId !== undefined)
      url_ += 'subscriptionId=' + encodeURIComponent('' + subscriptionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRemoveSubscription(_response);
    });
  }

  protected processRemoveSubscription(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  removeUser(userId: number | undefined): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Subscription/RemoveUser?';
    if (userId === null)
      throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined)
      url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: RequestInit = {
      method: 'DELETE',
      headers: {},
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processRemoveUser(_response);
    });
  }

  protected processRemoveUser(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }

  updateDomains(
    subscriptionId: number | undefined,
    domains: string[]
  ): Promise<void> {
    let url_ = this.baseUrl + '/api/v2/Subscription/UpdateDomains?';
    if (subscriptionId === null)
      throw new Error("The parameter 'subscriptionId' cannot be null.");
    else if (subscriptionId !== undefined)
      url_ += 'subscriptionId=' + encodeURIComponent('' + subscriptionId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(domains);

    let options_: RequestInit = {
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.http.fetch(url_, options_).then((_response: Response) => {
      return this.processUpdateDomains(_response);
    });
  }

  protected processUpdateDomains(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<void>(null as any);
  }
}

export interface AuditViewModel {
  id: number;
  activity: ActivitiesEnum;
  type: TypeEnum;
  modifiedOn: Date;
  modifiedBy?: string | null;
  entity?: string | null;
}

export enum ActivitiesEnum {
  Create = 0,
  Update = 1,
  Delete = 2,
  UpdateDomains = 3,
  Reset = 4,
  Extend = 5,
  UpdateMaxUsers = 6,
  AddProductVersion = 7,
  UpdateProductVersion = 8,
  RemoveProductVersion = 9,
}

export enum TypeEnum {
  Client = 0,
  Product = 1,
  Subscription = 2,
}

export interface FilterViewModel {
  create: boolean;
  modify: boolean;
  delete: boolean;
  to?: Date | null;
  from?: Date | null;
  clients?: number[] | null;
}

export interface Client {
  id: number;
  companyName?: string | null;
  subscriptions?: Subscription[] | null;
}

export interface Subscription {
  id: number;
  clientId: number;
  client?: Client | null;
  productId: number;
  product?: Product | null;
  domains?: SubscriptionDomain[] | null;
  type: SubscriptionType;
  start: Date;
  expiration?: Date | null;
  maxUsers: number;
  remainingDemoPermissions: number;
  registeredUsers?: RegisteredUser[] | null;
  serialKeys?: SerialKey[] | null;
}

export interface Product {
  id: number;
  name?: string | null;
  productId: string;
  allowedSubscriptionTypes: SubscriptionType;
  productVersions?: ProductVersion[] | null;
}

export enum SubscriptionType {
  Demo = 1,
  PerUser = 2,
  FlatRate = 4,
  PerUserSharePoint = 8,
  FlatrateSharePoint = 16,
  SoftwareAssurance = 32,
}

export interface ProductVersion {
  id: number;
  productId: number;
  product?: Product | null;
  version?: string | null;
  release: Date;
}

export interface SubscriptionDomain {
  id: number;
  domain?: string | null;
  subscriptionId: number;
  subscription?: Subscription | null;
}

export interface RegisteredUser {
  id: number;
  emailAddress?: string | null;
  subscriptionId: number;
  subscription?: Subscription | null;
}

export interface SerialKey {
  id: number;
  key?: string | null;
  startDate: Date;
  expirationDate: Date;
  isExpired: boolean;
  subscriptionId: number;
  subscription?: Subscription | null;
}

export interface GetLicenseRequest {
  email?: string | null;
  productGuid: string;
}

export interface ProductSetting {
  clientId: number;
  productId: number;
  client?: Client | null;
  product?: Product | null;
  configuration?: string | null;
}

export interface SubscriptionViewModel extends Subscription {
  serialKey?: string | null;
  serialKeyExpirationDate?: Date | null;
  expiredSerialKeys?: SerialKeyDto[] | null;
}

export interface SerialKeyDto {
  key?: string | null;
  serialKeyExpirationDate?: Date | null;
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: {[key: string]: any};
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: {[key: string]: any},
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: {[key: string]: any},
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}
